import styled from 'styled-components';

const Source = styled.span`
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Pathway Gothic One', sans-serif;
  font-size: 16px;
  @media only screen and (min-width: 1024px) {
    font-size: 18px;
  }
`;
export default Source;
